import { useEffect, useState } from "react";
import { getMachineAvgOeeHistorical } from "../../Common/commonFunctions";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import { HistoricalTsiDataType } from "../../Types/portalTypes";
import AvgOeeAreaChart from "./areaChart";

interface Props {
  color: string;
  machinesByGroup: MachinesByGroup[];
  currentMachineIndex: number;
  groupHistoricalData: HistoricalTsiDataType;
}
const AvgOee: React.FC<Props> = (props) => {
  const { color, machinesByGroup, currentMachineIndex, groupHistoricalData } = props;
  const [avgOee, setAvgOee] = useState<number | null>(null);

  useEffect(() => {
    setAvgOee(getMachineAvgOeeHistorical(machinesByGroup, currentMachineIndex, groupHistoricalData));
  }, [currentMachineIndex, machinesByGroup, groupHistoricalData]);

  return (
    <div className="avg-oee-component-wrapper">
      <div className="flex space-between">
        <div>
          <div className="avg-oee-text">Average OEE</div>
          <div className="avg-oee-text-subtext">Last 90 Days</div>
        </div>
        <div className="avg-oee-percent" style={{ color: color }}>
          {avgOee + "%"}
        </div>
      </div>
      <AvgOeeAreaChart
        machinesByGroup={machinesByGroup}
        currentMachineIndex={currentMachineIndex}
        groupHistoricalData={groupHistoricalData}
        color={color}
      />
    </div>
  );
};

export default AvgOee;
